<template>
    <div id="product-list-details-page">
        <pre class="debug" v-if="isDebug">{{ recordDict }}</pre>
        <actions-menu>
            <actions-menu-item
                :v4="true"
                :action="
                    () => $router.push('/productpage/' + this.productList.id)
                "
                icon="arrow-left"
                :label="trans('pages.product_list_details.to_product')" />
            <actions-menu-item
                :v4="true"
                :action="markListSawn"
                icon="check"
                :label="trans('pages.product_list_details.completed')" />
            <actions-menu-item
                :v4="true"
                :action="removeList"
                class="alert"
                icon="exclamation-circle"
                :label="trans('pages.product_list_details.delete')" />
        </actions-menu>
        <loader v-if="loading" />
        <template v-else>
            <div class="container row">
                <div class="col-67">
                    <div class="paintlist-title">
                        <div v-if="allComplete">
                            <h2>
                                {{
                                    trans(
                                        'pages.product_list_details.list_completed'
                                    )
                                }}
                            </h2>
                        </div>
                    </div>
                </div>

                <div class="clearer" />

                <div class="box">
                    <div class="box-title">
                        {{ trans('pages.product_list_details.info') }}
                    </div>

                    <div class="box-row">
                        <div class="box-25">
                            {{
                                trans(
                                    'pages.product_list_details.creation_date'
                                )
                            }}
                        </div>
                        <div class="box-25">
                            <span v-if="productList">
                                {{ productList.createdAt }}
                            </span>
                        </div>

                        <div class="box-25">
                            {{ trans('pages.product_list_details.deadline') }}
                        </div>
                        <div class="box-25">
                            <span v-if="productList && productList.deadline">
                                {{ productList.deadline }}
                            </span>
                        </div>
                    </div>
                </div>

                <div class="clearer" />
            </div>

            <h4>
                {{ trans('pages.product_list_details.products_in_package') }}
            </h4>
            <div v-if="productList && productList.products">
                <div
                    class="productiditem link"
                    v-for="product in productList.products"
                    :key="'product.' + product.number"
                    @click="goToProductPage(product.id)">
                    {{ product.number }}
                </div>
            </div>

            <div class="clearer" />

            <br />
            <div
                class="product-table"
                v-if="
                    productList &&
                    (!productList.products || productList.products.length == 0)(
                        !productList.products ||
                            productList.products.length == 0
                    )
                ">
                <li>{{ trans('pages.product_list_details.no_products') }}</li>
            </div>
            <table
                cellspacing="0"
                cellpadding="0"
                id="pleatinglistdetails-profile-overview"
                class="product-table">
                <thead>
                    <tr class="product-table-header-tr">
                        <th class="product-table-header-td" />
                        <th class="product-table-header-td image-column">
                            {{ trans('pages.product_list_details.image') }}
                        </th>
                        <th class="product-table-header-td" align="left">
                            {{
                                trans('pages.product_list_details.description')
                            }}
                        </th>
                        <th class="product-table-header-td" align="center">
                            {{ trans('pages.product_list_details.finished') }}
                        </th>
                    </tr>
                </thead>
                <tbody v-if="productList && productList.products">
                    <template
                        v-for="[product, records] in productList.products.map(
                            (x) => [x, recordDict[x.id]]
                        )">
                        <tr
                            :key="'listProduct.' + product.number"
                            class="product-table-item-tr">
                            <td class="ball-column">
                                <div
                                    class="bol"
                                    :style="{
                                        backgroundColor: records.every(
                                            (record) => record.sawn == 1
                                        )
                                            ? 'green'
                                            : 'red',
                                    }" />
                            </td>
                            <td
                                align="center"
                                class="image-column"
                                valign="center">
                                <img
                                    class="pleatinglistProductImage"
                                    @click="selectedImageProduct = product"
                                    :src="product.imageSrc"
                                    :alt="product.number" />
                            </td>
                            <td align="left">
                                <div class="paintlistbold">
                                    {{ product.number }}
                                </div>
                                <div class="paintlistitalic">
                                    {{ product.reference }}
                                </div>
                                <div class="paintlistitalic">
                                    {{ product.color.ralNumber
                                    }}{{ product.color.ralType }}
                                </div>
                                <br />
                                <template v-for="record in records">
                                    <template
                                        v-for="firstSawline in (
                                            record.sawlist || []
                                        ).slice(0, 1)">
                                        <div
                                            class="paintlistdefault"
                                            :key="'sawline.record.' + record.id"
                                            :data-record-id="record.id">
                                            {{ firstSawline.name.trim() }}:
                                            {{ firstSawline.value }}
                                        </div>
                                    </template>
                                </template>
                            </td>
                            <td align="center">
                                <input
                                    type="checkbox"
                                    :checked="
                                        records.every(
                                            (record) => record.sawn == 1
                                        )
                                    "
                                    @change="onFinishToggle($event, records)" />
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </template>
        <image-modal
            v-if="selectedImageProduct"
            :source="selectedImageProduct.imageSrc"
            @modal-click="selectedImageProduct = null"
            :title="selectedImageProduct.number" />
    </div>
</template>
<script>
import ActionsMenu from '../components/ActionsMenu';
import ActionsMenuItem from '../components/ActionsMenuItem';
import productListApi from '../api/productList';
import Loader from '../components/loader/Loader';
import IsDebugMixin from '../mixins/is-debug';
import IdParamMixin from '../mixins/id-param';
import NavigationFunctionsMixin from '../mixins/navigation-functions';
import {
    showConfirmDialog,
    showInfoMessage,
    showErrorMessage,
} from '../dialogs';
import ImageModal from '../components/modals/ImageModal';
import localization from '../mixins/localization';

export default {
    components: {
        ImageModal,
        Loader,
        ActionsMenu,
        ActionsMenuItem,
    },
    mixins: [
        IsDebugMixin,
        IdParamMixin(),
        NavigationFunctionsMixin,
        localization,
    ],
    computed: {
        allComplete() {
            if (!this.productList) {
                return false;
            }

            const allComplete = (this.productList.products || []).every(
                (product) => {
                    const records = this.recordDict[product.id];
                    return records.every((record) => record.sawn == 1);
                }
            );

            if (allComplete) {
                window.scrollTo(0, 0);
            }

            return allComplete;
        },
    },
    data() {
        return {
            loading: true,
            productList: null,
            recordDict: null,
            selectedImageProduct: null,
        };
    },
    methods: {
        markListSawn() {
            showInfoMessage(
                this.trans('pages.product_list_details.status_update')
            );
            productListApi
                .updateSawn(
                    this.idParam,
                    this.$store.getters['currentUser/getUserId']
                )
                .then(() => {
                    this.$router.push('/productpage/' + this.productList.id);
                })
                .catch(() => {
                    showErrorMessage(
                        this.trans('pages.product_list_details.unknown_error')
                    );
                });
        },
        onFinishToggle(e, records) {
            e.target.disabled = true;
            const sawn = e.target.checked;
            const promises = records.map((record) => {
                return productListApi
                    .updateSawnForRecord(parseInt(record.id), sawn)
                    .then(() => {
                        record.sawn = sawn ? 1 : 0;
                    });
            });
            Promise.all(promises)
                .catch(() => {
                    showErrorMessage(
                        this.trans('pages.product_list_details.unknown_error')
                    );
                })
                .finally(() => {
                    e.target.disabled = false;
                });
        },
        createRecordDict() {
            const recordDict = {};
            this.productList.profiles.forEach((record) => {
                record.products.forEach((number) => {
                    if (!recordDict[number]) {
                        recordDict[number] = [];
                    }
                    recordDict[number].push(record);
                });
            });
            return recordDict;
        },
        load() {
            this.loading = true;
            productListApi
                .fetchDetails(this.idParam, true)
                .then((response) => {
                    const productList = response.data;
                    this.$store.commit(
                        'general/setPageTitle',
                        this.trans('pages.product_list_details.list_number', {
                            number: productList.number,
                        }),
                        { root: true }
                    );
                    productList.products.forEach((product) => {
                        product.imageSrc =
                            Config.url +
                            '/product/customImage/?productId=' +
                            product.number +
                            '&random=' +
                            Math.random();
                    });
                    this.productList = productList;
                    this.recordDict = this.createRecordDict();
                })
                .catch(() => {
                    showErrorMessage(
                        this.trans('pages.product_list_details.fetch_error')
                    );
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        removeList() {
            showConfirmDialog({
                title: this.trans('pages.product_list_details.delete_title'),
                content: this.trans(
                    'pages.product_list_details.delete_confirm'
                ),
                confirm: () => {
                    productListApi
                        .remove(this.idParam)
                        .then(() => {
                            this.$router.push(
                                '/productpage/' + this.productList.id
                            );
                            this.$router.push(
                                '/productpage/' + this.productList.id
                            );
                        })
                        .catch(() => {
                            showErrorMessage(
                                this.trans(
                                    'pages.product_list_details.delete_failed'
                                )
                            );
                        });
                },
                closeOnCancel: true,
                closeOnOk: true,
                confirmButton: this.trans('pages.product_list_details.yes'),
                cancelButton: this.trans('pages.product_list_details.no'),
            });
        },
    },
};
</script>
